export default __webpack_public_path__ + "static/media/generate-img.7d0c811f.svg";